module.exports = __webpack_public_path__ + "img/new_2.a02cf381.png";